"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentParagraph = void 0;
const react_1 = __importDefault(require("react"));
const rich_content_element_1 = require("../rich-content-element");
const styles_1 = require("./styles");
const RichContentParagraph = ({ children, path = 'root', bold, italic, color, fontSize }) => {
    return (react_1.default.createElement(styles_1.StyledParagraphs, null,
        react_1.default.createElement(rich_content_element_1.RichContentElement, { bold: bold, italic: italic, "data-cy": "paragraph", path: path, color: color, fontSize: fontSize }, children)));
};
exports.RichContentParagraph = RichContentParagraph;
